/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedPersonalizedFilterToast_shippingFilters$ref = any;
export type SbRespCollectionsComponents_shippingFilters$ref = any;
export type SbRespCollectionsComponents_shippingFilters = ReadonlyArray<{
    readonly " $fragmentRefs": SbSharedPersonalizedFilterToast_shippingFilters$ref;
    readonly " $refType": SbRespCollectionsComponents_shippingFilters$ref;
}>;



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespCollectionsComponents_shippingFilters",
    "type": "ShippingFilterType",
    "metadata": {
        "plural": true
    },
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedPersonalizedFilterToast_shippingFilters",
            "args": null
        }
    ]
} as any);
(node as any).hash = '441114fb61af5387249e29d8712705a4';
export default node;
